import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "IN_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#IN_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "IN_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#IN_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v8h32V0H0z", fill: "#FF8C1A" }), /* @__PURE__ */ e.createElement("path", { d: "M0 16v8h32v-8H0z", fill: "#5EAA22" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 12a4 4 0 108 0 4 4 0 00-8 0zm7 0a3 3 0 11-6 0 3 3 0 016 0z",
      fill: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.995 12.86l-.57 3.121.33-3.155-1.426 2.834 1.207-2.934-2.168 2.316 1.985-2.474-2.732 1.612 2.601-1.816-3.076.777 3.008-1.009-3.17-.121 3.17-.12-3.008-1.01 3.076.777-2.601-1.815 2.732 1.612-1.985-2.475 2.168 2.316-1.207-2.934 1.427 2.834-.332-3.155.57 3.12.572-3.12-.332 3.155 1.427-2.834-1.207 2.934 2.168-2.316-1.985 2.475 2.732-1.612-2.601 1.815 3.075-.777-3.007 1.01 3.17.12-3.17.121 3.008 1.01-3.076-.778 2.601 1.816-2.732-1.612 1.985 2.474-2.168-2.316 1.207 2.934-1.427-2.834.332 3.155-.571-3.12z",
      fill: "#3D58DB"
    }
  )))
);
export {
  t as default
};
